import React, { useState } from 'react';
import { registrarUsuario } from '../api/usuarios';
import { useNavigate } from 'react-router-dom';
import { useNotify } from '../components/NotificationProvider';
import { isValidEmail, isValidPhone } from '../utils/helpers';

const initialForm = {
  username: '',
  password: '',
  confirmPassword: '',
  email: '',
  nombreCompleto: '',
  telefono: '',
  fechaNacimiento: ''
};

const Register = () => {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { success: notifySuccess, error: notifyError } = useNotify();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const validateForm = () => {
    const username = form.username.trim();
    const email = form.email.trim();
    const nombreCompleto = form.nombreCompleto.trim();

    if (nombreCompleto.length < 3 || !/[a-zA-Z]/.test(nombreCompleto)) return 'Ingresa tu nombre completo';
    if (!isValidPhone(form.telefono)) return 'Ingresa un telefono valido';
    if (username.length < 3) return 'El usuario debe tener al menos 3 caracteres';
    if (!isValidEmail(email)) return 'Ingresa un correo valido';
    if (form.password.length < 6) return 'La contrasena debe tener al menos 6 caracteres';
    if (form.password !== form.confirmPassword) return 'Las contrasenas no coinciden';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      notifyError(validationError, { duration: 4000 });
      return;
    }

    const fechaISO = form.fechaNacimiento
      ? new Date(form.fechaNacimiento).toISOString().slice(0, 10)
      : null;

    const payload = {
      nombreUsuario: form.username.trim(),
      password: form.password,
      correo: form.email.trim(),
      nombreCompleto: form.nombreCompleto.trim(),
      telefono: form.telefono.trim(),
      fechaNacimiento: fechaISO,
      rol: 'usuario'
    };

    try {
      setSubmitting(true);
      const result = await registrarUsuario(payload);
      if (result.success) {
        notifySuccess('Usuario registrado correctamente', { duration: 4000 });
        navigate('/');
        return;
      }

      const msg = result.error || result.message || 'No se pudo registrar el usuario';
      setError(msg);
      notifyError(msg, { duration: 4500 });
    } catch (err) {
      const msg = err.message || 'No se pudo registrar el usuario';
      setError(msg);
      notifyError(msg, { duration: 4500 });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-8 rounded-xl shadow-lg mt-12">
      <h2 className="text-2xl font-bold mb-6 text-center">Crear cuenta nueva</h2>
      <form onSubmit={handleSubmit} noValidate className="space-y-4">
        <input
          type="text"
          name="nombreCompleto"
          placeholder="Nombre y apellido"
          value={form.nombreCompleto}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          maxLength={100}
          required
        />
        <input
          type="text"
          name="telefono"
          placeholder="Telefono ej: +56912345678"
          value={form.telefono}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          maxLength={30}
          required
        />
        <input
          type="text"
          name="username"
          placeholder="Usuario ej: felipe"
          value={form.username}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          maxLength={50}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Correo electronico"
          value={form.email}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          maxLength={100}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Contrasena"
          value={form.password}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          minLength={6}
          required
        />
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirmar contrasena"
          value={form.confirmPassword}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          minLength={6}
          required
        />

        {error && <div className="text-red-500 text-center text-sm">{error}</div>}
        <button
          type="submit"
          disabled={submitting}
          className="w-full py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold rounded disabled:opacity-60"
        >
          {submitting ? 'Registrando...' : 'Registrarse'}
        </button>
      </form>
    </div>
  );
};

export default Register;
